<template>
  <div class="card card-with-shadow border-0">
    <!-- <div class="card-header p-primary bg-transparent">
        <h5 class="card-title m-0">{{ $t("update_tasks") }}</h5>
      </div> -->
    <app-overlay-loader v-if="preloader" />
    <div class="card-body">
      <div v-if="active === 1">
        <form
          class="mb-0"
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="selectedUrl ? `crud/${task.id}` : `crud`">
          <div class="form-group row align-items-center">
            <div class="col-sm-6">
              <label for="inputs_title">{{ $t("title") }}</label>
              <app-input
                id="inputs_title"
                type="text"
                v-model="task.title"
                :required="true"
              />
            </div>
            <div class="col-sm-6">
              <label for="inputs_email">{{ $t("task_category") }}</label>
              <app-input
                id="task_category"
                type="search-select"
                :placeholder="$t('select_task_category')"
                :list="taskCategories"
                v-model="task.task_category_id"
                :required="true"
              />
              <p v-if="categoryAddShow == false" class="font-italic text-muted">
                {{ $t("shortcut_category_create") }} <span><a href="#" @click.prevent="addCategory()">{{$t("add_category")}}</a></span>
              </p>
              <div v-if="categoryAddShow == true" class="mt-3">
                <div class="d-flex align-items-center">
                  <app-input
                    class="mr-2 flex-grow-1"
                    type="text"
                    placeholder="Enter Category Name"
                    v-model="category_name"/>
                  <button type="submit"
                    class="btn btn-sm btn-primary mr-2"
                    @click.prevent="createCategory()">
                    {{ $t('save') }}
                  </button>
                  <a href="#" class="text-muted" @click.prevent="closeCategory()">
                      <app-icon name="x"/>
                  </a>
                </div>
                <small class="text-danger ml-2" v-html="message"></small>
              </div>
            </div>
          </div>
          <div class="form-group row align-items-center">
            <div class="col-sm-6">
              <label for="inputs_forms">{{ $t("forms") }}</label>
              <app-input
                type="multi-select"
                :isAnimatedDropdown="true"
                :placeholder="$t('forms')"
                :list="forms"
                v-model="task.form_id"
              />
              <p v-if="refreshShow == false" class="font-italic text-muted">
                {{ $t("shortcut_form_create") }} <span><a href="#" @click.prevent="createForm()">{{$t("create_new")}}</a></span>
              </p>
              <p v-if="refreshShow == true" class="font-italic text-muted">
                <a href="#" @click.prevent="refreshForm()">{{$t("refresh")}}</a><span> {{ $t("form_create_refresh") }}</span>              </p>
            </div>
            <div class="col-sm-6">
              <label>{{ $t("users") }}</label>
              <app-input
                type="multi-select"
                :placeholder="$t('select_user')"
                :list="users"
                v-model="task.select_users"
              />
              <p class="font-italic text-muted">
                {{ $t("shortcut_user_create") }} <span><a href="#" @click.prevent="addUser()">{{$t("add_user")}}</a></span>
              </p>
            </div>
          </div>
          <div class="form-group row align-items-center">
            <div class="col-sm-12">
              <label for="inputs_description">{{ $t("description") }}</label>
              <app-input
                id="inputs_description"
                type="textarea"
                v-model="task.description"
                :required="true"
              />
            </div>
          </div>
          <div class="form-group row align-items-center">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="form-group">
                <app-input
                  type="single-checkbox"
                  :list-value-field="$t('task_dependent')"
                  v-model="checked_task_dependent"
                />
              </div>
            </div>
          </div>

          <div
            class="form-group row align-items-center"
            v-if="checked_task_dependent"
          >
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="form-group">
                <label>{{ $t("dependent_task") }}</label>
                <app-input
                  type="search-select"
                  :placeholder="$t('select_dependent_task')"
                  :list="this.panddingTask"
                  v-model="task.dependent_task"
                />
              </div>
            </div>
          </div>
          <div class="form-group row align-items-center">
            <div class="col-sm-6">
              <label>{{ $t("start_date") }}</label>
              <app-input
                type="date"
                v-model="task.start_date"
                :placeholder="$t('select_valid_date')"
              />
              <!-- :min-date="new Date()" -->
            </div>
            <div class="col-sm-6">
              <label>{{ $t("start_time") }}</label>
              <app-input
                type="time"
                v-model="task.start_time"
                :placeholder="$t('select_valid_time')"
              />
            </div>
            <div class="col-sm-6">
              <label>{{ $t("due_date") }}</label>
              <app-input
                type="date"
                v-model="task.due_date"
                :placeholder="$t('select_valid_date')"
              />
            </div>
            <div class="col-sm-6">
              <label>{{ $t("end_time") }}</label>
              <app-input
                type="time"
                v-model="task.end_time"
                :placeholder="$t('select_valid_time')"
              />
            </div>
          </div>

          
          <div class="row" v-if="task.total_recuring_task">
            <div class="col-lg col-md-12 col-sm-12">
              <div class="form-group">
                <label class="text-success">This task has <b>{{ task.total_recuring_task }}</b> Repeated task</label>
              </div>
            </div>
          </div>
          <!-- <div class="form-group row align-items-center">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="form-group">
                <app-input
                  type="single-checkbox"
                  :list-value-field="$t('repeat')"
                  v-model="checked_repeat"
                />
              </div>
            </div>
          </div> -->
          <!-- <div
            class="form-group row align-items-center"
            style="align-items: end"
            v-if="checked_repeat"
          >
            <div class="col-lg-4 col-md-4 col-sm-12">
              <div class="form-group">
                <label>{{ $t("repeat_every") }}</label>
                <app-input type="number" v-model="task.repeat_every" />
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
              <div class="form-group">
                <label></label>
                <app-input
                  type="select"
                  :list="duraton"
                  v-model="task.select_duraton"
                />
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
              <div class="form-group">
                <label>{{ $t("cycles") }}</label>
                <app-input type="number" v-model="task.cycles" />
              </div>
            </div>
          </div> -->
          <div class="form-group row align-items-center">
            <!-- <div class="col-sm-6">
              <label for="inputs_tags">{{ $t("tags") }}</label>
              <app-input
                id="inputs_tags"
                type="text"
                v-model="task.tag"
                :required="true"
              />
            </div> -->
            <div class="col-sm-6">
              <label for="inputs_tags">{{ $t("priority") }}</label>
              <app-input
                id="inputs_tags"
                type="radio"
                :list="priority"
                v-model="task.priority"
              />
            </div>
          </div>
          <div class="form-group row align-items-center">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="form-group">
                <app-input
                  type="dropzone"
                  v-model="dropzone_files"
                />
                <small class="text-muted font-italic">
                  {{ $t("recommended_dropzone_file_validation") }}
                </small>
              </div>
            </div>
          </div>
          <div class="form-group row align-items-center">
            <div
              class="col-lg-2 col-md-2 col-sm-12"
              v-for="(val, index) in uploade_files"
              :key="index"
            >
              <div class="form-group">
                <img
                  :src="val.filename"
                  alt="uploaded file"
                  class="img-thumbnail"
                />
              </div>
              <span
                class="dz-remove"
                style="cursor: pointer"
                @click="deletefile(val.id)"
                >Remove file</span
              >
            </div>
          </div>
          <div class="form-group row align-items-center">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <button
                type="button"
                class="btn btn-primary mr-2 mt-2"
                data-dismiss="modal"
                @click.prevent="submitForm"
              >
                {{ $t("update") }}
              </button>
            </div>
          </div>
        </form>
      </div>
      <div v-if="active === 2">
        <shortcut-user-create :back="backTaskCreate"></shortcut-user-create>
      </div>

      
    </div>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../../../../app/Mixins/ModalMixin";
import AppLibrary from "../../../../../../Helpers/AppLibrary";
import {
  axiosPost,
  axiosGet,
  axiosDelete,
} from "../../../../../../Helpers/AxiosHelper";
import {
  COMPANY_JOB_SITE_TASK_SHOW,
  COMPANY_JOB_SITE_TASK_UPDATE,
  COMPANY_JOB_SITE_TASK_ADD,
  GET_TASK_CATEGORIES,
  BUYER_CERTIFICATE_FORMS,
  GET_COMPANY_USERS,
  DELETE_UPLOADED_FILE,
  TASK_CATEGORY_STORE,
} from "../../../../../../Config/ApiUrl";

export default {
  name: "AddModal",
  extends:AppLibrary,
  mixins: [FormMixin, ModalMixin],
  // props: {
  //   siteid:Number,
  //   getSite:Function
  // },
  data() {
    return {
      refreshShow: false,
      active: 1,
      cat: {},
      message: '',
      categoryAddShow: false,
      category_name: '',
      preloader: false,
      checked_task_dependent: false,
      checked_repeat: false,
      taskCategories: [],
      dropzone_files: [],
      uploade_files: [],
      forms: [],
      inputs: {},
      task: {
        form_id: [],
        select_users: [],
      },
      users: [],
      modalId: "demo-task-edit-Modal",
      modalTitle: this.$t("add"),
      priority: [
        {
          id: "high",
          value: "High",
        },
        {
          id: "medium",
          value: "Medium",
        },
        {
          id: "low",
          value: "Low",
        },
      ],
      duraton: [
        { id: "", value: "Choose One" },
        { id: "Day", value: "Day" },
        { id: "Week", value: "Weeks" },
        { id: "Month", value: "Month" },
        { id: "Year", value: "Year" },
      ],
    };
  },
  // created() {
  //   if (this.selectedUrl) {
  //     this.modalTitle = this.$t("edit_task");
  //     this.preloader = true;
  //   }
  //   else if(this.modalTitle == this.$t("add"))
  //   {
  //     this.task = {};
  //   }
  // },
  methods: {
    addUser() {
      this.title = this.$t("add_user");
      this.active = 2;
    },
    backTaskCreate(value) {
      this.getUsers();
      this.active = value;
    },
    addCategory() {
      this.categoryAddShow = true;
    },
    closeCategory() {
      this.categoryAddShow = false;
    },
    createCategory() {
      if (this.category_name == '') {
          this.message = 'Category name is required';
      }
      else {
        this.cat.category_name = this.category_name;
        axiosPost(TASK_CATEGORY_STORE, this.cat)
          .then((res) => {
            this.categoryAddShow = false;
            this.$toastr.s(res.data.message);
            this.getTaskCategories();
            this.category_name = '';
          })
          .catch((error) => {
            
          });
      }
    },
    deletefile(id) {
      axiosDelete(DELETE_UPLOADED_FILE + "/" + id)
        .then((res) => {
          

          this.$toastr.s(res.data.message);
        })
        .catch((error) => {
          this.$toastr.e(error);
        })
        .finally(() => {
          this.getTask();
        });
    },
    submitForm() {
      // this.preloader = true;
      // if (this.modalTitle == this.$t("edit_task")) {

      if (this.task.start_date) this.task.start_date = this.getDateFormatForBackend(this.task.start_date);
      this.task.start_time = this.task.start_time;
      if (this.task.due_date) this.task.due_date = this.getDateFormatForBackend(this.task.due_date);
      this.task.end_time = this.task.end_time;
      this.task.type = "task";
      let formData = new FormData();
      if (this.dropzone_files.length > 0) {
        this.dropzone_files.forEach((dropzone_file) =>
          formData.append(`dropzone_file[]`, dropzone_file)
        );
        this.task.fileType = 'files';

      }
      else {
        this.task.fileType = 'no_file';
      }

      Object.keys(this.task).forEach((key) => {
        formData.append(key, this.task[key]);
      });
      axiosPost(COMPANY_JOB_SITE_TASK_UPDATE, formData)
        .then((res) => {
          let close = this.$attrs["props"];
          close.back;
          this.$toastr.s(res.data.message);
        })
        .catch((error) => {
          
          this.$toastr.e(error);
        })
        .finally(() => {
          this.preloader = false;
          this.task = {};
          // $("#demo-task-edit-Modal").modal("hide");
          // let site = this.$attrs["props"];
          // site.getSite();
        });

      // }
      // else{
      //   this.task.siteid = this.siteid;
      //   let formData = new FormData();

      //     if (this.dropzone_files.length) {
      //       this.dropzone_files.forEach((dropzone_file) =>
      //         formData.append(`dropzone_file[]`, dropzone_file)
      //       );
      //     }

      //   Object.keys(this.task).forEach((key) => {
      //     formData.append(key, this.task[key]);
      //   });
      // // this.save(formData);
      //   axiosPost(COMPANY_JOB_SITE_TASK_ADD, formData)
      //   .then((res) => {
      //     
      //     this.$toastr.s(res.data.message);
      //   })
      //   .catch((error) => {
      //     
      //     this.$toastr.e(error);
      //   }).finally(() => {
      //     this.preloader = false;
      //     this.task = {};
      //     $("#demo-task-edit-Modal").modal("hide");
      //     this.getSite();
      //   });

      // }

      // this.save(this.inputs);
    },
    // afterSuccess(response) {
    //   this.$toastr.s(response.data.message);
    //   this.$hub.$emit("reload-" + this.tableId);
    // },

    // afterSuccessFromGetEditData(response) {
    //   // if (response.data.phone) this.phone = response.data.phone;
    //   this.task = response.data;
    //   this.preloader = false;
    // },
    getTask() {
      let id = this.$attrs["props"];
      axiosGet(COMPANY_JOB_SITE_TASK_SHOW + "/" + id.id)
        .then((res) => {
          this.task = res.data;
          let task_files = res.data.files;
          this.uploade_files = res.data.taskfiles;
          // this.dropzone_files = task_files;
          // task_files.forEach((task_file) =>
            
          //   this.dropzone_files.push(task_file)
          // );
          
          this.preloader = false;
        })
        .catch((error) => {
          
        });
    },
    getTaskCategories() {
      axiosGet(GET_TASK_CATEGORIES)
        .then((res) => {
          this.taskCategories = res.data;
        })
        .catch((error) => {
          
        });
    },
    getUsers() {
      axiosGet(GET_COMPANY_USERS)
        .then((res) => {
          this.users = res.data;
        })
        .catch((error) => {
          
        });
    },
    getForms() {
      axiosGet(BUYER_CERTIFICATE_FORMS)
        .then((res) => {
          this.forms = res.data;
        })
        .catch((error) => {
          
        });
    },
    refreshForm() {
      this.refreshShow = false;
      this.getForms();

    },
    createForm() {
      this.refreshShow = true;
      window.open('/admin/documentlibrary/mydocument', '_blank');
    },
  },
  mounted() {
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
    this.getTask();
    
    this.getTaskCategories();
    this.getForms();
    this.getUsers();
  },
};
</script>
